export default __webpack_public_path__ + "static/media/ic-supp-hay.afc7fc05.svg";